import { BaseResponse } from './internal/baseresponse';

export class TransactionCheckOFACResult extends BaseResponse {
  data: Array<String> = new Array<String>();
}



// WEBPACK FOOTER //
// ./src/app/response/transactioncheckofacresult.ts